import {EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {AbstractControl, FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged, filter} from 'rxjs/operators';

/**
 * Базовый класс для всех компонент, задающий общие стилевые атрибуты
 */

export class BaseFieldComponent implements OnDestroy, OnInit {
    @HostBinding('style.maxWidth.px') @Input() maxWidth: number;
    @HostBinding('style.width.px') @Input() width: number;

    @Input() marginBottom: number;

    @Input() validateOnBlur = true;
    @Input() className = '';
    @Input() fbControl: AbstractControl = new FormControl();

    /**
     * Можно ли редактировать поле или оно будет запрещено для редактирования?
     * Характер того, как реагировать на editable=false поле, определен в ngOnInit
     * @type {boolean}
     */
    @Input() editable = true;

    @Output() blur = new EventEmitter();

    protected subs: Subscription[] = [];

    ngOnInit() {
        if (!this.editable) {
            this.disableIfContent();
        }
    }

    ngOnDestroy() {
        this.subs.forEach(sub => sub.unsubscribe());
    }

    /**
     * Дизейблим поле, если в нем уже есть значение.
     * Пустое поле остается возможным для редактирования.
     */
    private disableIfContent() {
        const value: string = this.fbControl.value;

        if (!value) {
            return;
        }

        /**
         * Дизейблим поле только если оно валидно
         */
        this.fbControl.markAsTouched();
        this.fbControl.markAsDirty();
        this.fbControl.updateValueAndValidity();

        if (this.fbControl.valid) {
            this.fbControl.disable();
        }

        this.subs.push(
            /**
             * На тот случай, если в поле есть маска ввода и она изменит значение поля на новое и оно будет пустым - разрешаем редактировать
             */
            this.fbControl.valueChanges.pipe(
                debounceTime(30),
                distinctUntilChanged(),
                filter((v: string|null) => !Boolean(v)),
            ).subscribe(() => {
                this.fbControl.enable();
            }),
            /**
             * На всякий случай, если вдруг поле стало невалидным, то разрешаем его редактировать
             */
            this.fbControl.statusChanges.pipe(
                debounceTime(30),
                distinctUntilChanged()
            ).subscribe(() => {
                if (this.fbControl.invalid) {
                    this.fbControl.enable();
                }
            })
        );
    }
}
